import reformatSchedules from './reformat-schedules';

// The server (Api::ShootingScheduleResource#bookable_timeslots, option-aware) now
// returns the already span-checked start-times a sitting can be booked at, via the
// single source of truth (AppointmentAvailability). reformatSchedules just groups
// them by day. This is the fix for the Beyer HS "offered then rejected" bug: the
// client no longer does first-block-only span/stride math that disagreed with the
// booking validation.

const SCHOOL_ID = 695;

const schedules = [
  {
    schoolId: SCHOOL_ID,
    shootingDay: '2026-09-01',
    bookableTimeslots: [
      { time: '9:00 AM' },
      { time: '9:05 AM' },
      { time: '9:10 AM' },
    ],
  },
];

describe('reformatSchedules', () => {
  it('returns {} until the bookable timeslots have loaded', () => {
    const notLoaded = [{ schoolId: SCHOOL_ID, shootingDay: '2026-09-01' }];
    expect(reformatSchedules(notLoaded, SCHOOL_ID)).toEqual({});
  });

  it('groups the server bookable start-times by shooting day', () => {
    const result = reformatSchedules(schedules, SCHOOL_ID);

    expect(result['2026-09-01']).toEqual([
      { time: '9:00 AM' },
      { time: '9:05 AM' },
      { time: '9:10 AM' },
    ]);
  });

  it('passes the server times through verbatim (no client span/stride filtering)', () => {
    // Whatever the server deemed bookable for the chosen sitting is exactly what
    // is offered — a long sitting is no longer offered at a start the server
    // (and thus booking validation) would reject.
    const longSitting = [
      {
        schoolId: SCHOOL_ID,
        shootingDay: '2026-09-02',
        bookableTimeslots: [{ time: '10:00 AM' }, { time: '10:20 AM' }],
      },
    ];

    const result = reformatSchedules(longSitting, SCHOOL_ID);

    expect(result['2026-09-02'].map((t) => t.time)).toEqual(['10:00 AM', '10:20 AM']);
  });

  it('tags the Shoob-studio school (1075) day with an @ Shoob suffix', () => {
    const shoob = [
      {
        schoolId: 1075,
        shootingDay: '2026-09-03',
        bookableTimeslots: [{ time: '11:00 AM' }],
      },
    ];

    const result = reformatSchedules(shoob, SCHOOL_ID);

    expect(Object.keys(result)).toEqual(['2026-09-03 @ Shoob']);
    expect(result['2026-09-03 @ Shoob']).toEqual([{ time: '11:00 AM' }]);
  });
});
